
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/curriculum/hmh-into-reading",
      function () {
        return require("private-next-pages/curriculum/hmh-into-reading.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/curriculum/hmh-into-reading"])
      });
    }
  